<template>
  <div class="page-main">
    <div class="page-top">
      <div class="flex flex-y-center">
        <span class="m-r-5">关键字</span>
        <el-input
          v-model="keyword"
          size="mini"
          style="width: 240px"
          placeholder="仓库名称/编码/地址/负责人"
          clearable
        />
      </div>
      <el-button type="success" size="mini" @click="itemDo()">新增仓库</el-button>
    </div>

    <!-- 表格 -->
    <vxe-grid ref="refTable" v-bind="tableOptions">
      <template #default_warehouse_type="{ row }">
        {{ warehouseTypeText(row.warehouse_type) }}
      </template>
      <template #default_status="{ row }">
        <span :class="Number(row.status) === 1 ? 'c-green' : 'c-red'">
          {{ Number(row.status) === 1 ? '启用' : '停用' }}
        </span>
      </template>
      <template #default_operate="{ row }">
        <el-link type="primary" @click="itemDo(row)">编辑</el-link>
        <el-link type="danger" @click="itemDelete(row)">删除</el-link>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="tableOptions.pagerConfig" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-增改仓库 -->
    <PopupDo v-if="isShowPopupDo" :show.sync="isShowPopupDo" :id="detailId" @success="getListData" />
  </div>
</template>

<script>
export default {
  components: {
    PopupDo: () => import('../common/popup-do')
  },
  data() {
    return {
      keyword: '',
      allData: [],
      tableOptions: {
        loading: false,
        size: 'mini',
        border: true,
        height: this.$util.getViewHeight() - 36 - 148,
        pagerConfig: {
          currentPage: 1,
          pageSize: 20,
          total: 0,
          pageSizes: [10, 20, 50, 100]
        },
        columns: [
          { fixed: 'left', title: '序号', type: 'seq', width: 50 },
          { field: 'warehouse_code', title: '仓库编码', width: 120 },
          { field: 'warehouse_name', title: '仓库名称', width: 160 },
          { field: 'warehouse_type', title: '仓库类型', width: 100, slots: { default: 'default_warehouse_type' } },
          { field: 'address', title: '地址', minWidth: 180 },
          { field: 'manager', title: '负责人', width: 100 },
          { field: 'phone', title: '电话', width: 120 },
          { field: 'status', title: '状态', width: 80, slots: { default: 'default_status' } },
          { field: 'remark', title: '备注', minWidth: 140 },
          { title: '操作', fixed: 'right', width: 120, slots: { default: 'default_operate' } }
        ],
        data: []
      },
      isShowPopupDo: false,
      detailId: ''
    }
  },
  watch: {
    keyword() {
      this.tableOptions.pagerConfig.currentPage = 1
      this.refreshView()
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    warehouseTypeText(val) {
      const map = { 1: '普通仓', 2: '退货仓', 3: '虚拟仓', 4: '中转仓' }
      return map[Number(val)] || ''
    },
    getListData() {
      this.tableOptions.loading = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/newWarehouse/list',
        data: { currentPage: 1, pageSize: this.$constant.pageMax, sortData: 'id desc' }
      })
        .then((res) => {
          if (res.status === 200 && res.data.page) {
            this.allData = res.data.page.list || []
            this.tableOptions.pagerConfig.currentPage = 1
            this.refreshView()
          }
        })
        .catch(() => {})
        .then(() => {
          this.tableOptions.loading = false
        })
    },
    filteredData() {
      const kw = (this.keyword || '').trim().toLowerCase()
      if (!kw) return this.allData
      return this.allData.filter((row) => {
        const fields = [row.warehouse_name, row.warehouse_code, row.address, row.manager]
        return fields.some((f) => f && String(f).toLowerCase().includes(kw))
      })
    },
    refreshView() {
      const list = this.filteredData()
      const { currentPage, pageSize } = this.tableOptions.pagerConfig
      this.tableOptions.pagerConfig.total = list.length
      const start = (currentPage - 1) * pageSize
      this.tableOptions.data = list.slice(start, start + pageSize)
    },
    pageChange({ currentPage, pageSize }) {
      this.tableOptions.pagerConfig.currentPage = currentPage
      this.tableOptions.pagerConfig.pageSize = pageSize
      this.refreshView()
    },
    itemDo(row) {
      this.detailId = row === undefined ? '' : row.id
      this.isShowPopupDo = true
    },
    itemDelete(row) {
      this.$confirm('您确认要删除该仓库?', '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/newWarehouse/delete',
            params: { id: row.id }
          }).then((res) => {
            if (res.data.state !== 'fail') {
              this.$message.success('删除成功')
              this.getListData()
            }
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
  .page-top {
    position: relative;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
}
</style>
